import { render, staticRenderFns } from "./PatientListLog.vue?vue&type=template&id=6cb285d4&scoped=true"
import script from "./PatientListLog.vue?vue&type=script&lang=js"
export * from "./PatientListLog.vue?vue&type=script&lang=js"
import style0 from "./PatientListLog.vue?vue&type=style&index=0&id=6cb285d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb285d4",
  null
  
)

export default component.exports